import { render, staticRenderFns } from "./Partenairesv2.vue?vue&type=template&id=71a3344c&scoped=true&"
var script = {}
import style0 from "./Partenairesv2.vue?vue&type=style&index=0&id=71a3344c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a3344c",
  null
  
)

export default component.exports